import React from 'react'

import { Typography } from 'antd'
import classNames from 'classnames'

const { Text } = Typography

type Props = {
  paddingLeft?: boolean
  noPadding?: boolean
  children?: any
  noErrorHeight?: boolean
}

const FormItemError: React.FC<Props> = (props) => {
  const { noErrorHeight = false } = props
  return (
    <Text
      type="danger"
      className={classNames(
        'formik-field__error block',
        {
          'pl-24': props.paddingLeft,
        },
        {
          'pl-12': !props.paddingLeft,
        },
        {
          'p-0': props.noPadding || props.noErrorHeight,
        },
        {
          'h-auto': noErrorHeight,
        },
      )}
    >
      {props.children}
    </Text>
  )
}
export { FormItemError as FormError }
export default FormItemError
